const TOKEN_KEY = "PlantIQ_Token"

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch (e) {
    return sessionStorage.getItem(TOKEN_KEY)
  }
}

export const setToken = token => {
  // TODO
  // 根据当前是否记住登录状态选择存储方式
  // const storage = token.rememberMe ? localStorage : sessionStorage
  const storage = token.rememberMe ? localStorage : localStorage
  try {
    storage.setItem(TOKEN_KEY, token)
  } catch (e) {
    console.error("Token存储失败:", e)
  }
}

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/token.js